const AboutUs = ({aboutTitle, aboutDescription}) => {
    return (
        <div className="about-details-container">
            <h2 className="about-title">{aboutTitle}</h2>
            <p className="about-details">{aboutDescription} </p>
      </div>
    );
  };
  
  export default AboutUs;